module.exports = __webpack_public_path__ + "img/trufence_diagram_step4.e27eb791.svg";